import { PrimariaApi } from "../../api/api";

export const getPatientCip = async (api: PrimariaApi): Promise<string> => {
  return (await api.broker.send("get_patient_cip")) as string;
};
